// A short, human relative time ("2 hours ago") for a "last synced" or "as of"
// line, where making a reader subtract an absolute timestamp from now is
// exactly the friction a status line should remove.
//
// One rule for every app (spec 2026-10-08): admin-spa's LastRefreshLine and
// @region13/ui's InleagueLastRead both read it here.

import { plural } from './countCopy'

/** `null` reads as "never" (never synced); an unparseable string is returned
 *  as-is rather than thrown on. A time in the future reads as "just now". */
export function relativeTime(iso: string | null, now: Date = new Date()): string {
  if (!iso) return 'never'
  const then = new Date(iso)
  if (Number.isNaN(then.getTime())) return iso

  const seconds = Math.max(0, Math.round((now.getTime() - then.getTime()) / 1000))
  if (seconds < 60) return 'just now'

  const minutes = Math.round(seconds / 60)
  if (minutes < 60) return `${plural(minutes, 'minute')} ago`

  const hours = Math.round(minutes / 60)
  if (hours < 24) return `${plural(hours, 'hour')} ago`

  const days = Math.round(hours / 24)
  if (days < 30) return `${plural(days, 'day')} ago`

  const months = Math.round(days / 30)
  if (months < 12) return `${plural(months, 'month')} ago`

  const years = Math.round(months / 12)
  return `${plural(years, 'year')} ago`
}
